module.exports = __webpack_public_path__ + "img/prioritas_dg.95625eb4.png";